import { userConstants } from './../constants/user.constants';

const initialState = {};

export function getEmiHistory(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_EMIHISTORY_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.GET_EMIHISTORY_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.GET_EMIHISTORY_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}